import "bootstrap/dist/css/bootstrap.min.css"; import * as OFMSUI from "react-bootstrap"; import { Field, useFormik, FormikProvider, } from "formik"; import { useHistory } from "react-router-dom"; import React, { useState, useEffect } from 'react'; import { Form, InputGroup, Button, Table } from "react-bootstrap"; import HousingService from "../../../Services/HousingService"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader"; import { cloud_url } from "../../../Services/Configuration"; import axios from "axios"; import Swal from "sweetalert2"; import { FaFastBackward } from "react-icons/fa"; import ShowAlert from "../../alert";
import { AlphaNumericValidation, NumberValidation } from "../../utils/commonFunctions";

const InterBankTransfer = () => {
  const [bankList, setbankList] = useState([]); const [bankListI, setbankListI] = useState([]); const [transactionId, setTransactionId] = useState(); const [receipt_id, setreceipt_id] = useState(""); const [saveSum, setSaveSum] = useState(""); const [selectedBank, setSelectedBank] = useState('');
  const [acBalance, setBalance] = useState(''); const [bankData, setBankData] = useState([]); const [bankDataI, setBankDataI] = useState([]); const [bankData2, setBankData2] = useState([]);

  const today = new Date().toISOString().split('T')[0]
  const history = useHistory();

  React.useEffect(() => {
    let params = { save_flag_Payment_Receipts_Journal: "Payment", };
    HousingService.getPaymentReceiptId(params).then((res) => {
      const id = res.data[0].payment_receipt_id; setTransactionId(id);
    });

    let param = { save_flag_Payment_Receipts_Journal: "Receipt", };
    HousingService.getPaymentReceiptId(param).then((res) => {
      const recid = res.data[0].payment_receipt_id; setreceipt_id(recid);
    });

    HousingService.fetchBank().then((res) => {
      if (res.data) {
        setBankData(res.data)
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>
            );
          }
        });
        setbankList(options);
      }
    });
    HousingService.fetchBank().then((res) => {
      if (res.data) {
        setBankDataI(res.data)
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>
            );
          }
        });
        setbankListI(options);
      }
    });

  }, []);
  const [selectedFile, setSelectedFile] = useState(""); const [uploadedFile, setUploadedFile] = useState("");

  const handleFileChange = (event) => {
    setSelectedFile(event.currentTarget.files[0]);
    if (event.currentTarget.files[0]) {
      handleUpload(event.currentTarget.files[0]);
    }
  };

  // const handleUpload = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     HousingService.fileUploadUrl(formData).then((response) => {
  //       resolve(response.data);
  //       formik.setFieldValue("upload_copy", response.data)
  //     }).catch((error) => { console.log("(File name should not contain symbols or special characters.)", error) });
  //   });
  // };

  const handleUpload = (file) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", file);

      HousingService.fileUploadUrl(formData)
        .then((response) => {
          formik.setFieldValue("upload_copy", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.error(error);

          ShowAlert(
            "File name should not contain symbols or special characters.",
            "error"
          );

          reject(error);
        });
    });
  };

  const getPdf = (transactionId, receipt_id) => {
    HousingService.getinerbankPdf(transactionId, receipt_id).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      let tab = window.open(); tab.location.href = url;
      setTimeout(() => { window.location.reload(); }, 2000);
    });
  };
  const formik = useFormik({
    initialValues: {
      payment_id: transactionId,
      receiptno: "",
      date: today,
      banknameaccountno: "",
      balance_in_account: "",
      receipt_description: "",
      paymentamount: 0,
      mode: "",
      cheque_dd_receipt_no: "",
      no_of_banks: "",
      upload_copy: "",
      interbankreq: [{ receipt_id: receipt_id, banknameaccountno1: '', balance_in_account1: '', receiptamount: '' }],

    },
    validate: (values) => {
      const errors = {}
      if (!values.receiptno) {
        errors.receiptno = "Required!";
      }
      if (!values.date) {
        errors.date = "Required!";
      }
      if (!values.banknameaccountno) {
        errors.banknameaccountno = "Required!";
      }

      if (!values.receipt_description) {
        errors.receipt_description = "Required!";
      }
      // if (!values.paymentamount) {
      //   errors.paymentamount = "Required!";
      // }
      if (!values.paymentamount) {
        errors.paymentamount = "Required!";
      } else if (Number(values.paymentamount) <= 0) {
        errors.paymentamount = "Transferred Amount must be greater than 0";
      }
      if (!values.mode) {
        errors.mode = "Required!";
      }
      if (!values.cheque_dd_receipt_no) {
        errors.cheque_dd_receipt_no = "Required!";
      }
      if (!values.upload_copy) {
        errors.upload_copy = "Upload copy is required!";
      }

      if (values.interbankreq && values.interbankreq.length > 0) {
        const interbankErrors = [];

        values.interbankreq.forEach((item, index) => {
          const rowErrors = {};

          // From Bank and To Bank cannot be same
          if (
            values.banknameaccountno &&
            item.banknameaccountno1 &&
            values.banknameaccountno === item.banknameaccountno1
          ) {
            rowErrors.banknameaccountno1 =
              "From Bank and To Bank cannot be same";
          }

          // Duplicate destination bank
          const duplicateCount = values.interbankreq.filter(
            x =>
              x.banknameaccountno1 &&
              x.banknameaccountno1 === item.banknameaccountno1
          ).length;

          if (item.banknameaccountno1 && duplicateCount > 1) {
            rowErrors.banknameaccountno1 =
              "This bank is already selected";
          }

          // Amount validation
          if (
            values.interbankreq.length > 1 &&
            (!item.receiptamount || Number(item.receiptamount) <= 0)
          ) {
            rowErrors.receiptamount =
              "Amount must be greater than 0";
          }

          if (Object.keys(rowErrors).length > 0) {
            interbankErrors[index] = rowErrors;
          }
        });

        if (interbankErrors.length > 0) {
          errors.interbankreq = interbankErrors;
        }
      }


      return errors;
    },
    onSubmit: (values, index) => {
      console.log("onSubmit1 CALLED", values);
      if (parseInt(saveSum) == parseInt(values.paymentamount)) {
        let formObj1 = { ...values }
        formObj1.payment_id = transactionId;
        formObj1.balance_in_account = acBalance;
        formObj1.paymentamount = parseFloat(values.paymentamount);
        formObj1.interbankreq.forEach(item => {
          item.receiptamount = parseFloat(item.receiptamount);
        });
        console.log("InterBankTransferInsertion CALLED 1 ")
        console.log(formObj1)
        Swal.fire({ text: "Do you want Submit?", icon: "success", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes" }).then((result) => {
          if (result.isConfirmed) {
            HousingService.InterBankTransferInsertion(formObj1).then(
              (response) => {
                console.log("InterBankTransferInsertion CALLED 2")
                if (response?.data[0]?.SDESC === "Data Submitted Successfully") {
                  ShowAlert("Details Submiited Successfully", "success").then(function (isConfirm) {
                    if (isConfirm.value) {
                      let receipt_IDs = [];
                      formObj1.interbankreq.forEach(item => {
                        receipt_IDs.push(item.receipt_id);
                      });
                      getPdf(transactionId, receipt_IDs);
                      setTimeout(() => { window.location.reload(); }, 1000);
                    }
                  }).catch((error) => {
                    ShowAlert("Failed to Submit", "error")
                  });

                }
              }
            );
          }
        })
      } else {
        ShowAlert("Check the amount", "warning")
        console.log("Sum of rows is greater than the transferred amount.");
      }
    },
  });
  useEffect(() => {
    formik.setValues({
      ...formik.values,
      interbankreq: [{ receipt_id: receipt_id, banknameaccountno1: '', balance_in_account1: '', receiptamount: '' }],
    });
  }, [receipt_id]);



  function isValidNumber(number) {
    return 0 <= number && number <= 10;
  }
  const display = (e) => {
    const selectedBank = bankData.find((bank) => bank.banknameaccountno === e.target.value);
    if (selectedBank) {
      setBalance(selectedBank.remaining_balance);
    } else {
      setBalance('select bank account');
    }
    return;
  };



  const arraySum = () => {
    let sum = formik.values.interbankreq.reduce(
      (sum, row) => (sum + parseFloat(row.receiptamount || 0, 10)),
      0
    );
    setSaveSum(sum)
    console.log("Sum", sum);
  };
  const addRow = () => {
    const nextReceiptId = getNextReceiptId(formik.values.interbankreq);
    const updatedReceipts = [
      ...formik.values.interbankreq,
      { receipt_id: nextReceiptId, banknameaccountno1: '', balance_in_account1: '', receiptamount: '' },
    ];

    formik.setValues({
      ...formik.values,
      interbankreq: updatedReceipts,
    });
  };

  const getNextReceiptId = (receipts) => {
    let maxNumericPart = 0;

    receipts.forEach(receipt => {
      const numericPart = parseInt(receipt.receipt_id.substring(1)); // Exclude the 'R'
      maxNumericPart = Math.max(maxNumericPart, numericPart);
    });

    const nextReceiptId = 'R' + String(maxNumericPart + 1).padStart(10, '0'); // Assuming a fixed length of 10 for the numeric part
    return nextReceiptId;
  };

  const removeRow = (index) => {
    const updatedReceipts = formik.values.interbankreq.filter((_, i) => i !== index);
    formik.setValues({
      ...formik.values,
      interbankreq: updatedReceipts,
    });
  };
  const getBankBal = (e, index) => {
    let params = { banknameaccountno: e.target.value }
    HousingService.Bank_AC_Bal(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>
            );
          }
        });
        setBankData2(options);
        formik.setFieldValue(`interbankreq.${index}.balance_in_account1`, res.data[0].remaining_balance);
      }
    });
    return;
  }

  const checkAmount = (e) => {
    if (parseFloat(e.target.value) > parseInt(acBalance)) {
      ShowAlert("Transferred Amount must be less than Avaliable balance", "warning").then(() => formik.setFieldValue("paymentamount", ""));
    }
  }

  return (
    <>
      <NavigationServicesHeader />
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <OFMSUI.Container>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}>INTER BANK TRANSFER</h1> </div>
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                <button
                  className="btn btn-primary btn-sm"
                  style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }}
                  type="reset"
                  onClick={() => history.goBack()}
                >
                  <FaFastBackward /> &nbsp;Back
                </button>
                <div className="d-grid  "></div>
              </OFMSUI.Col>
            </OFMSUI.Row>
          </OFMSUI.Container>
          <OFMSUI.Container className="outer-page-content-container ">
            <OFMSUI.Row className="p-4">
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                <label> <b>Transaction ID No</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field
                  value={transactionId}
                  name="payment_receipt_id"
                  className={formik.touched.payment_receipt_id && formik.errors.payment_receipt_id ? "form-control is-invalid" : "form-control"}
                  type="text"
                  maxLength={10}
                  disabled={true}
                />
                {formik.touched.payment_receipt_id && formik.errors.payment_receipt_id ? (<div className="invalid-feedback"> {formik.errors.payment_receipt_id} </div>) : null}
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                <label> <b>Voucher No</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field name="receiptno" className={formik.touched.receiptno && formik.errors.receiptno ? "form-control is-invalid" : "form-control"} type="text" maxLength={10} onKeyPress={(e) => AlphaNumericValidation(e)} />
                {formik.touched.receiptno && formik.errors.receiptno ? (<div className="invalid-feedback"> {formik.errors.receiptno} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                <label> <b> From Bank Name & Account No</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field
                  component="select"
                  name="banknameaccountno"
                  onChange={(e) => { formik.handleChange(e); display(e); }}
                  className={formik.touched.banknameaccountno && formik.errors.banknameaccountno ? "form-control is-invalid" : "form-control"}
                >
                  <option value="">--Select--</option>
                  {bankList}
                </Field>
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                <label> <b>Available Balance</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field
                  name="bankbalance"
                  value={acBalance}
                  disabled={true}
                  className={formik.touched.balance_in_account && formik.errors.balance_in_account ? "form-control is-invalid" : "form-control"}
                />
                {formik.touched.balance_in_account && formik.errors.balance_in_account ? (<div className="invalid-feedback"> {formik.errors.balance_in_account} </div>) : null}
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                <label> <b>Date of Transaction</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field
                  name="date"
                  className={formik.touched.date && formik.errors.date ? "form-control is-invalid" : "form-control"}
                  type="date"
                  max={today}
                />
                {formik.touched.date && formik.errors.date ? (<div className="invalid-feedback">{formik.errors.date}</div>) : null}
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                <label> <b>Description of Transaction</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field
                  style={{ height: "38px" }}
                  name="receipt_description"
                  as="textarea"
                  className={formik.touched.receipt_description && formik.errors.receipt_description ? "form-control is-invalid" : "form-control"}
                />
                {formik.touched.receipt_description && formik.errors.receipt_description ? (<div className="invalid-feedback"> {formik.errors.receipt_description} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                <label> <b>Transferred Amount</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field name="paymentamount" className={formik.touched.paymentamount && formik.errors.paymentamount ? "form-control is-invalid" : "form-control"} type="text"
                  onKeyPress={(e) => NumberValidation(e)}
                  onKeyUp={(e) => checkAmount(e)} maxLength={15} />
                {formik.touched.paymentamount && formik.errors.paymentamount ? (<div className="invalid-feedback"> {formik.errors.paymentamount} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                <label> <b>Payment Mode</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field name="mode" className={formik.touched.mode && formik.errors.mode ? "form-control is-invalid" : "form-control"} onChange={(e) => formik.handleChange(e)} component="select" >
                  <option>Select</option>
                  {/* <option value="Cash"> Cash </option> */}
                  <option value="Cheque">Cheque</option>
                  <option value="DD">DD</option>
                  <option value="NEFT/RTGS"> Online </option>
                </Field>
              </OFMSUI.Col>
              {formik.values.mode === "Cash" && (
                <>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                    <label> <b>If Cash Recieved(Receipt No) :</b> </label>
                    <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                    <Field
                      name="cheque_dd_receipt_no"
                      className={formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? "form-control is-invalid" : "form-control"}
                      type="text"
                      maxLength={10}
                    />
                    {formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? (<div className="invalid-feedback"> {formik.errors.cheque_dd_receipt_no} </div>) : null}
                  </OFMSUI.Col>
                </>
              )}
              {formik.values.mode === "Cheque" && (
                <>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                    <label> <b>Cheque</b> </label>
                    <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                    <Field
                      name="cheque_dd_receipt_no"
                      className={formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? "form-control is-invalid" : "form-control"}
                      type="text"
                    />
                    {formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? (<div className="invalid-feedback"> {formik.errors.cheque_dd_receipt_no} </div>) : null}
                  </OFMSUI.Col>
                </>
              )}
              {formik.values.mode === "DD" && (
                <>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                    <label> <b>DD</b> </label>
                    <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                    <Field
                      name="cheque_dd_receipt_no"
                      className={formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? "form-control is-invalid" : "form-control"}
                      type="text"
                    />
                    {formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? (<div className="invalid-feedback"> {formik.errors.cheque_dd_receipt_no} </div>) : null}
                  </OFMSUI.Col>
                </>
              )}
              {formik.values.mode === "NEFT/RTGS" && (
                <>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                    <label> <b>NEFT/RTGS</b> </label>
                    <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                    <Field
                      name="cheque_dd_receipt_no"
                      className={formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? "form-control is-invalid" : "form-control"}
                      type="text"
                      s />
                    {formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? (<div className="invalid-feedback"> {formik.errors.cheque_dd_receipt_no} </div>) : null}
                  </OFMSUI.Col>
                </>
              )}
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="m-2" >
                <label> <b>File Upload (File name should not contain symbols or special characters.)</b> <span className="text-danger"></span> </label>
                <InputGroup>
                  <input
                    type="file"
                    name="upload_copy"
                    onChange={handleFileChange}
                    className={formik.touched.upload_copy && formik.errors.upload_copy ? "form-control is-invalid" : "form-control"}
                    accept=".pdf"
                  />
                </InputGroup>
                {formik.touched.file && formik.errors.file ? (
                  <div className="invalid-feedback">{formik.errors.file}</div>
                ) : null}
              </OFMSUI.Col>

            </OFMSUI.Row>
            <OFMSUI.Row>
              <table className="table table-bordered" id="my-table" style={{ marginLeft: "5px" }}>
                <thead className="fw-bold">
                  <tr className="table_countshead">
                    <td style={{ width: "20%" }}>Transaction Id No.</td> <td>Bank Name</td> <td style={{ width: "20%" }}>Balance In Account (Rs/-) </td> <td style={{ width: "20%" }}>Amount (Rs/-)</td> <td style={{ width: "20%" }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {formik.values.interbankreq.map((receipt, index) => (
                    <tr key={index}>
                      <td>
                        <div>
                          <input
                            id={`interbankreq.${index}.receipt_id`}
                            name={`interbankreq.${index}.receipt_id`}
                            disabled={true}
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.interbankreq[index].receipt_id}
                          />
                        </div>
                        <button type="button" onClick={() => removeRow(index)} style={{ color: "red" }}>Remove</button>
                      </td>
                      <td>
                        <div>
                          <Field
                            id={`interbankreq.${index}.banknameaccountno1`}
                            name={`interbankreq.${index}.banknameaccountno1`}
                            className={formik.touched[`interbankreq.${index}.banknameaccountno1`] && formik.errors[`interbankreq.${index}.banknameaccountno1`] ? "form-control is-invalid" : "form-control"}
                            onChange={(e) => { formik.handleChange(e); getBankBal(e, index); }}
                            component="select"
                          >
                            <option>Select</option>
                            {bankListI}
                          </Field>
                          {/* {formik.touched.interbankreq && formik.touched.interbankreq[index] && formik.errors.interbankreq && formik.errors.interbankreq[index] ? (
                            <div className="invalid-feedback">{formik.errors.interbankreq[index]}</div>
                          ) : null} */}
                          {formik.errors.interbankreq?.[index]?.banknameaccountno1 && (
                            <div className="text-danger">
                              {formik.errors.interbankreq[index].banknameaccountno1}
                            </div>
                          )}

                        </div>

                      </td>
                      <td>
                        <div>
                          <Field
                            id={`interbankreq.${index}.balance_in_account1`}
                            name={`interbankreq.${index}.balance_in_account1`}
                            disabled={true}
                            className={formik.touched[`interbankreq.${index}.balance_in_account1`] && formik.errors[`interbankreq.${index}.balance_in_account1`] ? "form-control is-invalid" : "form-control"}
                            type="text"
                          />
                        </div>
                        {formik.touched[`interbankreq.${index}.balance_in_account1`] && formik.errors[`interbankreq.${index}.balance_in_account1`] ? (
                          <div className="invalid-feedback">{formik.errors[`interbankreq.${index}.balance_in_account1`]}</div>
                        ) : null}
                      </td>
                      {/* <td>
                        <div>
                          <Field
                            id={`interbankreq.${index}.receiptamount`}
                            name={`interbankreq.${index}.receiptamount`}
                            className={formik.touched[`interbankreq.${index}.receiptamount`] && formik.errors[`interbankreq.${index}.receiptamount`] ? "form-control is-invalid" : "form-control"}
                            onKeyUp={(e) => { formik.handleChange(e); arraySum(); }}
                            type="text"
                          />
                        </div>
                        {formik.touched[`interbankreq.${index}.receiptamount`] && formik.errors[`interbankreq.${index}.receiptamount`] ? (
                          <div className="invalid-feedback">{formik.errors[`interbankreq.${index}.receiptamount`]}</div>
                        ) : null}
                      </td> */}
                      <td>
                        <div>
                          <Field
                            id={`interbankreq.${index}.receiptamount`}
                            name={`interbankreq.${index}.receiptamount`}
                            type="text"
                            className={
                              formik.errors.interbankreq?.[index]?.receiptamount
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onKeyUp={(e) => {
                              formik.handleChange(e);
                              arraySum();
                            }}
                          />
                        </div>

                        {formik.errors.interbankreq?.[index]?.receiptamount && (
                          <div className="invalid-feedback d-block">
                            {formik.errors.interbankreq[index].receiptamount}
                          </div>
                        )}
                      </td>
                      <td> <button type="button" onClick={addRow} style={{ color: "green" }}>Add Bank</button> </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={3} style={{ textAlign: "end" }}>Total</td> <td><div><Field value={saveSum} className={"form-control"} disabled={true} /></div></td> <td></td>
                  </tr>
                </tfoot>
              </table>


              <br />
            </OFMSUI.Row>
            <br></br>
            <OFMSUI.Row className="m-2">
              <center> <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}> {" "} <button className="btn btn-success btn-sm" type="submit"> Submit </button> </OFMSUI.Col> </center>
            </OFMSUI.Row>
          </OFMSUI.Container>
        </Form>
      </FormikProvider>
    </>
  );
};

export default InterBankTransfer;
